import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './pages/security/login/auth-guard.service';
import { LoginComponent } from './pages/security/login/login.component';
import { AdminAreaComponent } from './pages/theme/adminarea/adminarea.component';
import { AboutComponent } from './pages/about/about.component';
import { ContactComponent } from './pages/contact/contact.component';
import { HomepageComponent } from './pages/homepage/homepage.component';
import { PortfolioComponent } from './pages/portfolio/portfolio.component';
import { ServicesComponent } from './pages/services/services.component';
import { BlogComponent } from './pages/blog/blog.component';

const routes: Routes = [
  { path: '', redirectTo: '/homepage', pathMatch: 'full' },
  {
    path: 'homepage', component: HomepageComponent,
  },
  {
    path: 'login-admin', component: LoginComponent,
  },
  {
    path: 'about', component: AboutComponent,
  },
  {
    path: 'portfolio', component: PortfolioComponent,
  },
  {
    path: 'services', component: ServicesComponent,
  },
  {
    path: 'contact', component: ContactComponent,
  },
  {
    path: 'blog', component: BlogComponent,
  },
  {
    path: 'blog/:id', component: BlogComponent,
  },
  {
    path: 'vikram777raj', component: AboutComponent,
  },
  {
    path: 'admin-area', component: AdminAreaComponent, canActivate: [AuthGuardService],
    loadChildren: () => import('./pages/admin/admin-services.module').then(mod => mod.AdminServiceModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
